import Div, { DivProps } from './div';

type StackingButtonsProps = Pick<DivProps, 'marginTop'> & {
    button1: JSX.Element
    button2: JSX.Element
}

const StackingButtons = ({ button1, button2, marginTop = 3 }: StackingButtonsProps) => {

    return (
        <Div
            isRow
            marginTop={marginTop}
            className="stacked-button"
        >
            <Div cols={12} colsMD={'auto'} paddingRightMD={1}>
                {button1}
            </Div>
            <Div
                cols={12} marginTop={1}
                colsMD={'auto'} marginTopMD={0} paddingLeftMD={0}
            >
                {button2}
            </Div>
        </Div>
    );
};

export default StackingButtons;